import { joinString } from '../shared/utils';
import { containersApi } from './api';
import { sortOptions } from './options';

const baseUri = 'notes';

export const NotesAPI = {
  get: ({ type, noteEntityKey, lineNumber }) =>
    containersApi.get(`${baseUri}/${type}`, {
      params: {
        noteEntityKey,
        lineNumber: Array.isArray(lineNumber)
          ? joinString(lineNumber, ',')
          : lineNumber,
      },
    }),
  getNoteAreaOptions: (noteType) =>
    containersApi.get(`${baseUri}/note-area-options/${noteType}`),
  editNote: ({ noteType, note }) =>
    containersApi.put(`${baseUri}/${noteType}`, note),
  addNote: ({ noteType, note }) =>
    containersApi.post(`${baseUri}/${noteType}`, note),
};

export const getNoteAreaOptions = async ({ noteType }) => {
  const { data: noteAreas } = await NotesAPI.getNoteAreaOptions(noteType);
  noteAreas?.forEach((na) => {
    na.type = noteType;
    na.value = na.area;
    na.label = na.area;
  });
  return sortOptions(noteAreas);
};
